import React from "react";

const GlobalConfig = new window.globalConfig();

class App extends React.Component {
  constructor(props) {
    super();

    let urlapi =
      GlobalConfig.REACT_APP_API_SYSTEMCONFIG_URL +
      `likename/` +
      props.configType;
    if (props.configType === process.env.REACT_APP_CONFIG_NAME_BONUS_DEDUCT) {
      urlapi = urlapi + "/" + props.processorId;
      if (props.onlyBaseAttribute) {
        urlapi = urlapi + `?onlyBaseAttribute=${props.onlyBaseAttribute}`;
      }
    }
    this.state = {
      controlId: props.controlId,
      urlapi: urlapi,
      value: props.value,
      data: [],
    };
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
  }

  async componentDidMount() {
    //using for parent call method setSelected outside
    this.props.onRef(this);

    //query all items in module and render as checkbox list
    this.getItems();
  }

  componentWillUnmount() {
    //using for parent call method setSelected outside
    this.props.onRef(undefined);
  }

  getItems = async () => {
    try {
      const that = this;
      fetch(this.state.urlapi)
        .then(function (response) {
          return response.json();
        })
        .then(function (resultObject) {
          if (
            resultObject &&
            resultObject.result === "OK" &&
            resultObject.data
          ) {
            const parsedItems = [];
            const attributes = resultObject.data;
            attributes.map((item) => {
              parsedItems.push({
                _id: item,
                name: item,
                checked:
                  that.state.value == null ||
                  that.state.value === undefined ||
                  that.state.value.indexOf(item) === -1
                    ? false
                    : true,
              });
            });
            that.setState({
              data: parsedItems,
            });
          }
        })
        .catch(function (error) {
          window.showAlert("Error", error, "error");
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  setSelected(selectedIds) {
    this.setState({ value: selectedIds });
    if (this.state.data) {
      let updatedData = this.state.data;
      updatedData.forEach((item) => {
        if (
          selectedIds == null ||
          selectedIds === undefined ||
          selectedIds.indexOf(item._id) === -1
        ) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
      this.setState({ data: updatedData });
    }
  }

  handleChangeSelect(event) {
    // var id = event.target.name;
    const value = event.target.value;
    this.setState({ value: value });
    this.props.handleChangeSelectControl(this.state.controlId, value);
  }

  reset = () => {
    this.setState({
      value: "",
    });
  };

  render() {
    return (
      <select
        disabled={this.props.readOnly}
        name={this.state.controlId}
        className={`form-control select-config-size ${this.props.className}`}
        required={this.props.required}
        onChange={this.handleChangeSelect}
        value={this.state.value}
        style={this.props.style}
      >
        <option value="">
          {this.props.label ? this.props.label : "Choose one"}
        </option>
        {this.state.data
          ? this.state.data.map((item, key) => {
              return (
                <option value={item._id} key={item._id}>
                  {item.name}
                </option>
              );
            })
          : ""}
      </select>
    );
  }
}
export default App;
